export function isEditing(){
    return window && window.wp && window.wp.editor;
}
